/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { CAN_CREATE_NEW_APP } from '../../api/graphql';
import { APPLICATION_TYPE } from '@/config/applicationType.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface ICanCreateNewAppMethods extends IPluginMethodMap {
  canCreateNewApp(args: any): Promise<any>;
}

export class CanCreateNewAppService implements IAgentPlugin {
  readonly methods: ICanCreateNewAppMethods;

  constructor() {
    this.methods = {
      canCreateNewApp: this.canCreateNewApp.bind(this),
    };
  }

  async canCreateNewApp(args: any) {
    console.log(`args in user lists service`, args);
    const storageService = StorageModule.getInstance();

    const localToken = storageService.get('myProfile', 'local');
    const sessionToken = storageService.get('myProfile', 'session');
    const vuid = localToken?.vuid ?? sessionToken?.vuid;
    console.log('po->', vuid);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(CAN_CREATE_NEW_APP, {
          input: { ...args },
        });
        console.log(`reach->`, res);
        if (res?.data?.canCreateNewApp) {
          console.log(`table data222`, res);
          console.log('reach->');

          console.log('reach->');
          return this.format(res?.data?.canCreateNewApp);
        } else {
          console.log('reach->');
          return null;
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return null;
    }
  }

  private format(data: any) {
    const msgArr = data?.message?.split(' ');
    let msg = '';
    if (Array.isArray(msgArr) && msgArr.length > 0) {
      msg = 'A ' + APPLICATION_TYPE?.[msgArr?.[1]] + ' ';
      for (let i = 2; i < msgArr.length; i++) {
        msg += msgArr?.[i] + ' ';
      }
    }
    if (data?.canCreate) {
      return data;
    }
    return {
      ...data,
      message: msg,
    };
  }
}
